import { combineReducers } from "@reduxjs/toolkit";

import { LanguageCode } from "common/types/languageCode";
import type { FetchLanguageAction } from "domains/language/actionTypes";
import { LanguageDomainActionType } from "domains/language/actionTypes";
import type { LanguageDomainState, Terms } from "domains/language/types";

export const initialState: LanguageDomainState = {
  byId: {},
  isFetching: false,
  siteLanguage: LanguageCode.EN,
};

const byId = (state = initialState.byId, action: FetchLanguageAction) => {
  switch (action.type) {
    case LanguageDomainActionType.FETCH_FULFILLED:
      return action.payload.terms.reduce<Terms>(
        (accumulator, { term, value }) => ({ ...accumulator, [term]: value }),
        {},
      );
    default:
      return state;
  }
};

const isFetching = (state = initialState.isFetching, action: FetchLanguageAction) => {
  switch (action.type) {
    case LanguageDomainActionType.FETCH:
      return true;

    case LanguageDomainActionType.FETCH_FULFILLED:
    case LanguageDomainActionType.FETCH_REJECTED:
      return false;

    default:
      return state;
  }
};

const siteLanguage = (state = initialState.siteLanguage, action: FetchLanguageAction) => {
  switch (action.type) {
    case LanguageDomainActionType.FETCH:
    case LanguageDomainActionType.FETCH_FULFILLED:
      return action.meta.language;

    default:
      return state;
  }
};

export const languageReducer = combineReducers({ byId, isFetching, siteLanguage });
